/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect,useState } from 'react';
import './menu.css';
import { FaSolarPanel } from 'react-icons/fa';
import { IoMdAlarm } from 'react-icons/io';
import { BsSun, BsLightning } from 'react-icons/bs';
import { BiSend, BiLogOut } from 'react-icons/bi';
import {RiTerminalWindowLine} from 'react-icons/ri';
import {GiPowerGenerator} from "react-icons/gi";
import {CiViewTable} from "react-icons/ci";
import logo from '../../images/Login/logo.svg';
function Menu() {
    var screens = JSON.parse(sessionStorage.getItem('ScreenConfiguration'));
    //Recogemos el estado de las pantallas, esto es si se van a ver o no
    const [enabledMap,setEnabledMap] = useState('');
    const [enabledCommands,setEnabledCommands] = useState('');
    const [enabledInv,setEnabledInv] = useState('');
    const [enabledMeteo,setEnabledMeteo] = useState('');
    const [enabledEM,setEnabledEM] = useState('');
    const [enabledPLC,setEnabledPLC] = useState('');
    const [enabledAlarms,setEnabledAlarms] = useState('');
    const [enabledST,setEnabledST] = useState('');

    async function checkSession(){
        const response = await fetch(window.location.protocol+"//"+window.location.hostname+"/api" + "/sessions/sessionStatus", { method: 'GET', credentials: 'include' });
        if (response.status === 401){
            sessionStorage.clear();          
            window.location.reload();
        }
    }

    let number = 0;
    useEffect(() => {
        checkSession();
        setInterval(function () {
        number++;
        checkSession();
        }, 10000)
    }, [number]);

    const cerrarSesion = () => {
        fetch(window.location.protocol+"//"+window.location.hostname+"/api" + '/sessions/logout', {
        method: 'DELETE',
        credentials: 'include'
        })
        .then(response => {sessionStorage.removeItem("configuration");sessionStorage.clear(); window.location.reload();})
        .catch(e => { console.error(e);})
    }
    

    useEffect(()=>{
        for(let i = 0;i<screens.length;i++){
            switch(screens[i].Screen){
                case 'Map':
                    if(screens[i].Enabled === false){
                        setEnabledMap('none');
                    }
                break;
                case 'Commands':
                    if(screens[i].Enabled === false){
                        setEnabledCommands('none');
                    }
                break;
                case 'Inverter':
                    if(screens[i].Enabled === false){
                        setEnabledInv('none');
                    }
                break;
                case 'Meteo':
                    if(screens[i].Enabled === false){
                        setEnabledMeteo('none');
                    }
                break;
                case 'EnergyMeter':
                    if(screens[i].Enabled === false){
                        setEnabledEM('none');
                    }
                break;
                case 'PLC':
                    if(screens[i].Enabled === false){
                        setEnabledPLC('none');
                    }
                break;
                case 'Logs':
                    if(screens[i].Enabled === false){
                        setEnabledAlarms('none');
                    }
                break;
                case 'Substation':
                    if(screens[i].Enabled === false){
                        setEnabledST('none');
                    }
                break;
                default:
                    console.log()
                break;
            }
        }
    },[]);

    return(<>
        <div className='div-menu-component' id='menu-large-width'>
            <img id="logo" style={{width:"7rem",marginLeft:"1rem",marginRight:"1rem"}} src={logo} alt="logo"/>
            <a className='route-button' onClick={() => { window.open("/#/mapa", "_self") }} ><FaSolarPanel/> Parque</a>
            <a className='route-button' style={{display:enabledCommands}} onClick={() => { window.open("/#/comandos", "_self") }}><BiSend/> Comandos</a>
            <a className='route-button' style={{display:enabledInv}} onClick={() => { window.open("/#/listaInv", "_self") }}><CiViewTable/>Inversores</a>
            <a className='route-button' style={{display:enabledMeteo}} onClick={() => { window.open("/#/meteo", "_self") }}><BsSun/> Meteo</a>
            <a className='route-button' style={{display:enabledEM}} onClick={() => { window.open("/#/analizador", "_self") }}><BsLightning/> Analizador</a>
            <a className='route-button' style={{display:enabledPLC}} onClick={() => { window.open("/#/plc", "_self") }}><RiTerminalWindowLine/> PLC</a>
            <a className='route-button' style={{display:enabledST}} onClick={() => {window.open("/#/substation", "_self")}}><GiPowerGenerator/> Subestación</a>
            <a className='route-button' style={{display:enabledAlarms}} onClick={() => { window.open("/#/alarmas", "_self") }}><IoMdAlarm/> Alarmas</a>
            <a className='logout-button' onClick={cerrarSesion}><BiLogOut/> Cerrar sesión</a>
        </div>
        <div className='div-menu-component' id='menu-short-width'>
            <a className='route-button'  onClick={() => { window.open("/#/mapa", "_self")}}><FaSolarPanel/></a>
            <a className='route-button' style={{display:enabledCommands}} onClick={() => { window.open("/#/comandos", "_self")}}><BiSend/></a>
            <a className='route-button' style={{display:enabledInv}} onClick={() => { window.open("/#/listaInv", "_self") }}><CiViewTable/></a>
            <a className='route-button' style={{display:enabledMeteo}} onClick={() => { window.open("/#/meteo", "_self")}}><BsSun/></a>
            <a className='route-button' style={{display:enabledEM}} onClick={() => { window.open("/#/analizador", "_self")}}><BsLightning/></a>
            <a className='route-button' style={{display:enabledPLC}} onClick={() => { window.open("/#/plc", "_self")}}><RiTerminalWindowLine/></a>
            <a className='route-button' style={{display:enabledST}} onClick={() => {window.open("/#/substation", "_self")}}><GiPowerGenerator/></a>
            <a className='route-button' style={{display:enabledAlarms}} onClick={() => { window.open("/#/alarmas", "_self")}}><IoMdAlarm/></a>
            <a className='logout-button' onClick={cerrarSesion}><BiLogOut/></a>
        </div>
    </>
    );
    
}

export default Menu